<template>
    <div class="col-md-10">
        <input type="text" class="form-control" id="in_price" :value="data.price"  @keyup="onInputChange">
    </div>
</template>

<script>
import { STORE_NAMES } from "@/vuex/store";

const STORE_MODULE = STORE_NAMES.MANAGEMENT_STORE;

export default {
  name: "management-list-input",
  props: {
      data: {
      type: Object,
    },
  },
  data() {
    return {
        debouncer: null,
        storeName: STORE_MODULE,
    };
  },
  methods: {
    onChangeInput(val) {
        console.log(val);
    },
    onInputChange(evt) {
      const { value } = evt.target;

      if (this.debouncer != null) {
        clearTimeout(this.debouncer);
      }

      this.debouncer = setTimeout(() => {
        this.onChangeInput(value);
      }, 500);
    }
  },
};
</script>